import { connect } from 'react-redux';
import { userInfoSelector } from 'Store/user-info/userInfo.selectors';

const connector = connect(state => ({ userInfo: userInfoSelector(state) }));
export function userInfoWrapper(ComponentToWrap) {
  return connector(ComponentToWrap);
}
